/**
 * navigation.js
 * 
 * Übewacht die Shop-Navigation und toggelt die Dropdowns der einzelnen Überpunkte sobald diese mit 
 * der Maus überfahren oder verlassen werden. Zudem wird ein Überpunkt bei Tablets durch erneuten 
 * Klick aufrufbar gemacht. 
 * 
 * @version   1.0.0
 * @author    Erwin Müller Versandhaus GmbH
 */
var Navigation = (function(){ 

  /**
   * Helfer-Objekt für das sperren von Elementen auf der Hauptebene
   * 
   * @since   1.0.0
   * @var     {object}  _itemLock 
   */
  var _dropdownDelay;

  /**
   * Dropdown Höhe berechnen
   * 
   * Durchläuft verfügbarere Unterpunkte des Dropdowns und ermittelt dabei den höchsten Wert. Dieser 
   * wird mit dem Padding ergänzt und zurückgegeben
   * 
   * @since   1.0.0
   * @param   {Node}    dropdown  Dropdown DOM-Node
   * @return  {number}  Dropdown Höhe
   */
  function _calculateDropdownHeight(dropdown){ 
    // Grundhöhe über Menüpunkte Links ermitteln
    var dropdownHeight = $(dropdown).outerHeight();

    // Unterpunkte durchlaufen um höchstes Element zu ermitteln
    $(dropdown).children('.menu-item').each(function(){
      var itemHeight = 0;

      if ( $(this).hasClass('menu-item-direct') ) { // Virtuell gruppierte Unterelemente
        var submenuHeight = 0;

        $(this).children('.submenu').children().each(function(){
          // Absolut positionierte Gruppen
          if ( $(this).hasClass('group-service') || $(this).hasClass('group-service-info') ) { 
            var submenu = $(this).children('.submenu');
            // Höhe durch Position + Höhe der Unterpunkte ermitteln
            groupHeight = submenu.offset().top - $(this).offset().top + submenu.outerHeight(true);
          } else { 
            groupHeight = $(this).outerHeight(true);
          }

          // Submenu Höhe aktualisieren
          submenuHeight += groupHeight;
          
          // Standard Offset anrechnen
          groupHeight += 5;

          // Element Höhe überschreiben fall aktuelle Gruppe höher ist
          if ( groupHeight > itemHeight ) { 
            itemHeight = groupHeight;
          }
        })

        // Submenu Höhe verwenden falls Itemhöhe überschritten wird
        if( $('body').hasClass('department-mt') && submenuHeight > itemHeight ){
          itemHeight = submenuHeight;
        }


      } else if ( $(this).hasClass('menu-item-group-list') ) { // Virtuell gruppierte Unterelemente / Service
        $(this).children('.group-list').children().each(function(){
          var $submenu = $(this).children('.submenu');
          // Höhe durch Position + Höhe der Unterpunkte ermitteln
          var groupHeight = $submenu.offset().top - $(this).offset().top + $submenu.outerHeight(true);
          
          // Element Höhe überschreiben fall aktuelle Gruppe höher ist
          if ( groupHeight > itemHeight ) { 
            itemHeight = groupHeight;
          }
        })
      } else { // Reguläre Unterelemente
        var innerHeight = 0;
        
        if ( $(this).children('.submenu').hasClass('brand-logos') ) { 
          // console.log('C', this, $(this).children('.submenu'), $(this).children('.submenu').outerHeight(true) );
          itemHeight = $(this).children('.submenu').outerHeight(true);
        } else { 
          // Unterpunkte durchlaufen um Gesamt-Höhe zu ermitteln
          $(this).children('.submenu').children('.menu-item').each(function(){
          // console.log( 'B', this );
            innerHeight += $(this).outerHeight(true);
          });

          // Standard Offset anrechnen
          innerHeight += 5;

          // Element Höhe überschreiben falls Unterpunkte höher sind
          if ( innerHeight > itemHeight ) { 
            itemHeight = innerHeight;
          }
        }
      } 

      // Dropdown Höhe überschreiben falls Unterpunkt höher ist
      if ( itemHeight > dropdownHeight ) { 
        dropdownHeight = itemHeight;
      }
    })

    return Math.round( dropdownHeight );
  }

  /**
   * Dropdown Höhe setzten
   * 
   * Ermittelt die maximale Dropdownhöhe und schreibt diesen Wert in das `style` Attribut des Dropdowns
   * Elemente die bereits einen Höhe Wert haben werden ignoriert.
   * 
   * @since   1.0.0
   * @param   {Node}  item      Menpüunkt DOM-Node
   * @param   {Node}  dropdown 
   */
  function setDropdownHeight( item, dropdown ) { 
    if ( !$(item).hasClass('menu-item-level-1') || !$(item).hasClass('menu-item-has-children') ) return;

    // Prüfen ob die Dropdown Höhe bereits ermittelt wurde
    if ( !dropdown.style.height.length ) { 
      // Höhe ermitteln
      var height = _calculateDropdownHeight( dropdown );
      // console.log( height );
      // Inline Styling schreiben
      $(dropdown).css({ height: height + 'px' });
    }
  }

  /**
   * Element Zeile ermitteln 
   * 
   * Ermittelt die aktuelle Zeile des Menüpunkts um das Dropdown entsprecht anzupassen und korrekt
   * auszurichten
   * 
   * @since   1.0.0
   * @param   {Node}  item  Menüpunkt DOM-Node
   */
  function setDropdownPosition( item, dropdown ) { 
    if ( !$(item).hasClass('menu-item-level-1') || !$(item).hasClass('menu-item-has-children') ) return;

    // Prüfen ob die Dropdown Postion bereits ermittelt wurde
    if ( !dropdown.style.top.length ) { 
      // console.log( '[set position]', dropdown );
      var h = $(item).outerHeight(),
          i = $(item).offset(), 
          n = $(item.parentNode).offset()
          o = h + ( i.top - n.top );

      // Offset Top anpassen um Dropdown ausrichtung anzugleichen
      $(dropdown).css({ top: o + 'px' })
    }
  }

  var _self = { 
    version: '1.0.0', 

    /**
     * Constructor 
     * 
     * @since   1.0.0
     */
    init: function(){ 
      var navigation = $('#primary-site-navigation'),
          item = navigation.find('.menu-item');

      if ( $('body').hasClass('touch-device') ) { 
        // Dropdown Höhen beim Seiten-Aufruf berechnen
        $('#primary-site-navigation .menu-item-level-1.menu-item-has-children').each(function(){
          var dropdown = this.querySelector( '.nav-menu-level-2')
          setDropdownHeight( this, dropdown );
          setDropdownPosition( this, dropdown );
        })
        
        // Dropdown Toggle für Touch-Geräte
        $('.menu-item').on('click', function(e){
          var item = this;
          if ( $(e.target).hasClass('menu-item-title') && ( $(item).hasClass('menu-item-level-1') || $(item).hasClass('menu-item-level-2') ) && !$(item).hasClass('active') && $(item).hasClass("menu-item-has-children") ) { 
            e.preventDefault();
            _self.openDropdown( item );
          }
        });

        // Toggle Button
        $('.nav-menu-close').on('click', function(e){
          _self.closeDropdown( $(this).closest('.menu-item-level-1')[0] );
        })

        // Dropdown bei Klick außerhalb schließen
        $(window).on('click', function(e){
          var container = navigation;
          if ( !container.is( e.target ) && !container.has(e.target).length ) { 
            _self.closeDropdowns();
          }
        })

         $(window).scroll(function(){
          if ( $(this).scrollTop() > 180 ) {
            _self.closeDropdowns();
          }
         });
         
      } else { 

        item.on('mouseenter mouseover', function(e) {
          // Hauptpunkte nur öffnen wenn der Titel überfahren wird
          if ( $(this).hasClass('menu-item-level-2') && !$(e.target).hasClass('menu-item-title') ) return;

          if ( $(this).hasClass('menu-item-level-1') ) { 
            that = this;
            clearTimeout( _dropdownDelay );
            _dropdownDelay = setTimeout(function(){ 
              _self.openDropdown( that );
            }, 150 );
          } else { 
            clearTimeout( _dropdownDelay );
            _self.openDropdown( this );
          }
        })

        item.on('mouseleave', function(e){
          if ( $(this).hasClass('menu-item-level-2') ) { 
            // Erste/letzte Unterkategorie der Hauptebene immer aktiv lassen
            var offset = $(this).offset();
            if ( ( $(this).is(':first-child') && e.pageY < offset.top ) || ( $(this).is(':last-child') && e.pageY > offset.top ) ) return;
          }

          if ( $(this).hasClass('menu-item-level-1') ) { 
            if ( _dropdownDelay ) { 
              clearTimeout( _dropdownDelay );
            } else { 
              // Status Klasse entfernen
              $(this).removeClass('active');
              $(this).find('.menu-item.active').removeClass('active');
            }
          }

        })

        $('#primary-site-navigation').on('mouseleave', function(e){
          $(this).find('.menu-item.active').removeClass('active');
          clearTimeout( _dropdownDelay );
        })

        $(window).resize(function(){
          _self.resetNavigation();
        })
      }

      $('body').addClass('navigation-ready');
    },

  
    /**
     * Menüpunkt Dropdown öffnen
     * 
     * Dropdown des übergebenen Menüpunkts schließen
     * 
     * @since   1.0.0
     * @param   {Node}  item  Menüpunkt DOM-Node
     */
    openDropdown: function( item ) {
      if ( $(item).hasClass('active') ) return;
      
      // Aktive Punkte der selben Ebene deaktivieren
      $(item.parentNode).find('.menu-item.active').each(function(){
        $(this).removeClass('active');
      })

      if ( $(item).hasClass('menu-item-level-1') && $(item).hasClass("menu-item-has-children") ) { 
        // Dropdown Höhe & Position ermitteln + festlegen
        var dropdown = item.querySelector('.nav-menu-level-2')
        setDropdownHeight( item, dropdown );
        setDropdownPosition( item, dropdown );

        if ($("body").hasClass("touch-device") && $(item).find('.menu-item-level-2.current-menu-item-parent').length ) {
          $(item).find('.menu-item-level-2.current-menu-item-parent').addClass('active');

        } else {
          // Erste Unterkategorie der Hauptebene aktivieren um leeres Dropdown zu vermeiden
          $(item).find('.menu-item-level-2:first-of-type').addClass('active');
        }
        
      }

      // Status Klasse setzten
      $(item).addClass('active');
    },

    /**
     * Schließt ein Dropdowns
     * 
     * Schließt ein Dropdown durch entfernen der `active` Klasse
     * 
     * @since     1.0.0
     * @param     {Node}  [item]    Menüpunkt DOM-Node 
     */
    closeDropdown: function( item ) { 
      // Menpunkt schließen 
      $(item).removeClass('active');
      // Unterpunkte deaktivieren
      $(item).find('.menu-item.active').each(function(){
        $(this).removeClass('active');
      });
    },

    /**
     * Schließt alle Dropdowns
     * 
     * @since     1.0.0
     * @param     {Node}  [item]    Menüpunkt DOM-Node 
     */
    closeDropdowns: function() { 
      $('#primary-site-navigation .menu-item-level-1.active').each(function(){
        _self.closeDropdown( this );
      })
    },

    /**
     * Navigation zurücksetzen
     * 
     * Setzt die Navigation in die Uhrsprungszustand zurück indem alle aktiven Punkte geschlossen werden 
     * und sämtliche Inline-Styles entfernt werden
     * 
     * @since     1.0.0
     */
    resetNavigation: function(){ 
      $('#primary-site-navigation .active').each(function(){
        $(this).removeClass('active')
      })

      $('#primary-site-navigation .submenu').each(function(){ 
        $(this).removeAttr('style');
      })
    }
  }

  // Initialize
  $(function(){ 
    _self.init()  
  });

  return _self;
})();